<template>
  <div v-if="isCommunity">
    <div v-if="canEditCommunities">
      <a href="#" @click.prevent="handleEditCommunity">
        {{ community.name }}
      </a>
    </div>
    <div v-else>
      {{ community.name }}
    </div>
  </div>
</template>

<script>
import Permissions from '@/utilities/permissions'

export default {
  props: ['data'],
  computed: {
    isCommunity() {
      return !!(this.data && (this.data.id || this.data._id))
    },
    community() {
      if (!this.data) {
        return {}
      }
      return this.data
    },
    canEditCommunities() {
      return this.$can('edit', Permissions.COMMUNITIES)
    }
  },
  methods: {
    handleEditCommunity() {
      let communityId = this.community.id
      if (this.community._id && this.community._id != null) {
        communityId = this.community._id
      }
      this.$eventHub.$emit('show-modal-1', 'Community', {id: communityId}, '500px')
    }
  }
}
</script>
